import type { ReactionType } from "@/lib/humhub-api/types";

export const REACTION_ASSETS: Record<
  ReactionType,
  { src: string; fallbackEmoji: string; label: string; alt: string }
> = {
  like: {
    src: "/emotions/reaction-like.gif",
    fallbackEmoji: "👍",
    label: "Like",
    alt: "like",
  },
  love: {
    src: "/emotions/reaction-love.gif",
    fallbackEmoji: "❤️",
    label: "Love",
    alt: "love",
  },
  haha: {
    src: "/emotions/reaction-haha.gif",
    fallbackEmoji: "😂",
    label: "Haha",
    alt: "haha",
  },
  wow: {
    src: "/emotions/reaction-wow.gif",
    fallbackEmoji: "😮",
    label: "Wow",
    alt: "wow",
  },
  sad: {
    src: "/emotions/reaction-sad.gif",
    fallbackEmoji: "😢",
    label: "Sad",
    alt: "sad",
  },
  angry: {
    src: "/emotions/reaction-angry.gif",
    fallbackEmoji: "😡",
    label: "Angry",
    alt: "angry",
  },
  nicewatch: {
    src: "/emotions/reaction-nicewatch.png",
    fallbackEmoji: "⌚",
    label: "Nice Watch",
    alt: "nicewatch",
  },
  watChan: {
    src: "/emotions/reaction-wat-chan.png",
    fallbackEmoji: "🐬",
    label: "Wat Chan",
    alt: "watChan",
  },
};

export const REACTION_ORDER: ReactionType[] = [
  "like",
  "love",
  "haha",
  "wow",
  "sad",
  "angry",
  "nicewatch",
  "watChan",
];

export const createEmojiFallbackDataUri = (emoji: string) =>
  `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ctext y='18' font-size='18'%3E${encodeURIComponent(emoji)}%3C/text%3E%3C/svg%3E`;
